<template>
    <v-select
        :items="languages"
        v-model="currentLanguage"
        item-value="code"
        item-text="name"
        return-object
        @change="setLanguage"
        :solo="!showLabel"
        :flat="!showLabel"
        :dense="!showLabel"
        :label="showLabel ? $translate(label) : null"
        :hide-details="!showLabel"
        :style="style"
        background-color="transparent"
    >
    <template v-slot:selection="{ item }">
        <div class="selected-language">
            <img :src="getFlag(item.code)" class="flag-icon"> <template v-if="!compact">{{ item.name }}</template>
        </div>
    </template>
    <template v-slot:item="{ item }">
        <img :src="getFlag(item.code)" class="flag-icon"> {{ item.name }}
    </template>
</v-select>
</template>

<script>
export default {
    name: 'zoezi-language-menu',

    zoezi: {
        title: 'Language selector',
        icon: 'mdi-flag'
    },

    props: {
        showLabel: {
            title: 'Show label',
            type: Boolean,
            default: false
        },
        label: {
            title: 'Label',
            type: String,
            default: 'Language'
        },
        compact: {
            title: 'Compact style',
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        languages: [
            { name: 'English', code: 'en' },
            { name: 'Svenska', code: 'sv' }
        ],
        currentLanguage: null
    }),

    computed: {
      style() {
        if (this.compact) {
          return {
            'max-width': '70px'
          }
        }

        return null;
      }
    },

    watch: {
        '$store.state.language': {
            immediate: true,
            handler(lang) {
                this.currentLanguage = this.languages.find(l => l.code === lang);
            }
        }
    },

    methods: {
        getFlag(langCode) {
            if (!langCode) return '';
            return this.$api.getAssetUrl(`/assets/img/flags/${langCode}.png`);
        },
        setLanguage(lang) {
            this.$store.dispatch('setLanguage', {language: lang.code, changeOnServer: true});
            this.currentLanguage = lang;
        }
    }
}
</script>

<style scoped>
.flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 8px;
}

.select-language {
    display: flex;
    align-items: center;
}
</style>
